import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-stock-on-location',
  templateUrl: './stock-on-location.component.html',
  styleUrls: ['./stock-on-location.component.css']
})
export class StockOnLocationComponent implements OnInit {
    stockKeyno;

    functionName;

    public setting?: Setting;

    public itemsListStockOnLocations: Item[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
        this.functionName = this.stateService.getStateParams()['functionname'];
    }

    private async loadSetting() {
        if (!!this.stockKeyno && !!this.functionName) {
            this.setting = (await this.datatask.Post(458, {
                stock_keyno: this.stockKeyno,
                functionname: this.functionName
            }))[0];
        }
    }

    private async loadStockOnLocations() {
        if (!!this.setting) {
            this.itemsListStockOnLocations = await this.datatask.Post(459, {
                stock_keyno: this.setting.stock_keyno,
                functionname: this.setting.functionname
            });
        }
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('w_stockonlocation_grid')
                    .setLoadDataFunction({
                        method: 2577,
                        parameters: {
                            stock_keyno: this.setting.stock_keyno,
                            functionname: this.setting.functionname
                        }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadStockOnLocations();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
    prod_name: string;
    stock_keyno: string;
    functionname: string;
}
